<template>
  <div class="auth register">
    <div class="login-form">
      <div class="form-left">
        <div class="language">
          <ui-select-language
            menuContentClass="language-select-menu"
            :applyImmediately="true"
            @change="onLanguageChange"
          />
        </div>
        <div class="mb-10 mt-30">
          <img alt="BeMob" src="/images/logo-white2.svg" />
        </div>
        <p class="mb-32 pr-30">
          {{
            t(
              'BeMob helps to manage your ad campaigns, identify the most profitable traffic sources, measure your landing pages performance and provide highly detailed real-time reports.',
            )
          }}
        </p>
        <div class="login-signup">
          <template v-if="step === 1">
            <div>{{ t('Already have an account?') }}</div>
            <ui-button
              class="mt-4"
              :to="{ path: 'login' }"
              :text="t('Sign in')"
              icon="fas fa-sign-in-alt"
            />
          </template>
          <template v-if="step === 2 || step === 3">
            <ui-button
              :to="{ path: 'logout' }"
              :text="t('Logout')"
              icon="fas fa-sign-in-alt"
            />
          </template>
        </div>
        <div class="copyright">
          2015-{{ currentYear }}
          {{ t('© BeMob. All rights reserved.') }}
        </div>
      </div>

      <div class="form-right">
        <div :class="['form-right-inner', `step-${step}`]">
          <component :is="formComponent" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import RegisterForm1 from '@/views/pages/components/register-form1.vue';
import RegisterForm2 from '@/views/pages/components/register-form2.vue';
import RegisterForm3 from '@/views/pages/components/register-form3.vue';
import { patchUserApiRequest } from '@/services/api/user-api';
import { useStore } from '@/store';
import { useI18n } from '@/composables';

const { t } = useI18n();
const route = useRoute();
const store = useStore();

const currentYear = new Date().getFullYear();

const step = computed(() => {
  switch (route.name) {
    case 'register-email-verification':
      return 2;
    case 'register-currency':
      return 3;
    default:
      return 1;
  }
});

const formComponent = computed(() => {
  switch (step.value) {
    case 2:
      return RegisterForm2;
    case 3:
      return RegisterForm3;
    default:
      return RegisterForm1;
  }
});

const onLanguageChange = (language: string) => {
  if (step.value === 2 || step.value === 3) {
    patchUserApiRequest({ language }).then(res => {
      const userPayload = res.data.payload;
      store.$patch(state => {
        state.user = { ...state.user, ...userPayload };
      });
    });
  }
};
</script>

<style lang="scss" scoped>
.form-right-inner {
  &.step-1 {
    min-height: 581px;
  }

  &.step-3 {
    min-height: 400px;
  }
}
.form-wrapper {
  min-height: 484px;
}
</style>
